<!-- <mat-progress-spinner
    mode="indeterminate"
    color="primary"
    [diameter]="lSize"
></mat-progress-spinner> -->

<div class="loader__init js-loader-init">
    <div class="loader__anim bg-blue"></div>
    <div class="loader__anim bg-blue-darken-3"></div>
    <div class="loader__anim bg-blue-lighten-1"></div>
</div>
{{ message }}